<template>
	<div class="crystal-amount">
		+{{ props.amount.toLocaleString() }}
		<img :src="crystalPng" class="crystal-icon" />
	</div>
</template>

<script setup lang="ts">
import crystalPng from '@/assets/images/crystal.png';

const props = defineProps<{
	amount: number;
}>();
</script>

<style scoped>
.crystal-amount {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;

	font-weight: 700;
	font-size: 16px;
	line-height: 19px;

	color: #ffffff;
}

.crystal-icon {
	width: 13.68px;
	height: 16px;

	filter: drop-shadow(0px 0px 50px rgba(0, 132, 255, 0.52));
	transform: rotate(0.94deg);
}
</style>
